import React from "react";
import { Spinner } from "../Spinner/Spinner";
import PropTypes from "prop-types";

import style from "./StatsTableGym.module.css";

import { useDateFormater } from "../../Hooks/useDateFormater";
import { Link } from "react-router-dom";
import { useUTCLocalConvertor } from "../../Hooks/UTCLocalConvertor";
import { dateFormatEnum } from "../../assets/Js/dateFormatEnum";

export default function StatsTableGym({ tableData, isLoading }) {
  const dateFormater = useDateFormater();
  const UTCLocal = useUTCLocalConvertor();

  return (
    <div class="row">
      <div class="col-md-12 stretch-card">
        <div class="card">
          <div class="card-body">
            <p class="card-title mb-1">Recently Joinned Athletes</p>

            <p class="text-primary mb-4">
              <span className="hover-cursor">
                <Link
                  to={{
                    pathname: "/dashboard/manageathletes",
                  }}
                >
                  View all athletes
                </Link>
              </span>
            </p>

            {isLoading ? (
              <div className="my-5">
                <Spinner />
              </div>
            ) : (
              <div class="table-responsive">
                <div
                  id="recent-purchases-listing_wrapper"
                  class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer"
                >
                  <div class="row">
                    <div class="col-sm-12 col-md-6"></div>
                    <div class="col-sm-12 col-md-6"></div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12">
                      <table
                        id="recent-purchases-listing"
                        class="table table-striped"
                        role="grid"
                      >
                        <thead>
                          <tr role="row">
                            <th
                              class={`sorting_asc ${style.tableHeading}`}
                              tabindex="0"
                              aria-controls="recent-purchases-listing"
                              rowspan="1"
                              colspan="1"
                              style={{ width: "169.05px" }}
                              aria-sort="ascending"
                              aria-label="Name: activate to sort column descending"
                            >
                              Name
                            </th>
                            <th
                              class={`sorting ${style.tableHeading}`}
                              tabindex="0"
                              aria-controls="recent-purchases-listing"
                              rowspan="1"
                              colspan="1"
                              style={{ width: "216.383px" }}
                              aria-label="Status report: activate to sort column ascending"
                            >
                              Email
                            </th>
                            <th
                              class={`sorting ${style.tableHeading}`}
                              tabindex="0"
                              aria-controls="recent-purchases-listing"
                              rowspan="1"
                              colspan="1"
                              style={{ width: "152.15px" }}
                              aria-label="Office: activate to sort column ascending"
                            >
                              Joinning Date
                            </th>
                            <th
                              class={`sorting ${style.tableHeading}`}
                              tabindex="0"
                              aria-controls="recent-purchases-listing"
                              rowspan="1"
                              colspan="1"
                              style={{ width: "74.0333px" }}
                              aria-label="Price: activate to sort column ascending"
                            >
                              Status
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {tableData.map((eachEntery) => (
                            <tr role="row" class="odd">
                              <td class="sorting_1">{eachEntery.UserName}</td>
                              <td>{eachEntery.Email}</td>
                              <td>
                                {dateFormater(
                                  UTCLocal({
                                    type: dateFormatEnum.local,
                                    date: eachEntery.JoinedOn,
                                  })
                                )}
                              </td>
                              <td>
                                {eachEntery.Status ? (
                                  <span className="badge-success p-1">
                                    Active
                                  </span>
                                ) : (
                                  <span className="badge-danger rounded p-1">
                                    In Active
                                  </span>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12 col-md-5"></div>
                    <div class="col-sm-12 col-md-7"></div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

StatsTableGym.propTypes = {
  tableData: PropTypes.array,
  isLoading: PropTypes.bool,
};
